<template>
    <div>
		<tab name="1"></tab>
		<el-radio-group v-model="tabList" size="small" class="MB20 MT10">
		    <el-radio-button :label="1" v-if="$utils.have('/service/template/list')" >服务说明</el-radio-button>
		    <el-radio-button v-if="$utils.have('/service/template/list')" :label="2">购票须知</el-radio-button>
		    <el-radio-button v-if="$utils.have('/service/template/list')" :label="3">观演须知</el-radio-button>
		</el-radio-group>
		<activity-sever-list v-if="tabList == 1"></activity-sever-list>
		<activity-sale-list v-else-if="tabList == 2"></activity-sale-list>
		<activity-watch-list v-else-if="tabList == 3"></activity-watch-list>
		
        
    </div>
</template>
<script>

import Tab from './components/tab'
import ActivitySaleList from './components/activity-sale-list'
import ActivitySeverList from './components/activity-sever-list'
import ActivityWatchList from './components/activity-watch-list'

export default {
	components:{Tab,ActivitySaleList,ActivitySeverList,ActivityWatchList},
    data() {
        return {
           
			tabList: 1,
        };
    },
    mounted() {
		
    },
	computed: {
		
		
	},
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/service/template/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },

        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            }
            this.getDataList();
        },
		add(type){
			this.$router.replace({
			    path: `/system/serviceTemplate/add/${type}`,
			    query: {
			        v: this.$utils.uuid(),
			        redirect: this.$utils.objArgs(
			            this.$router.currentRoute.path,
			            this.params
			        ),
			    },
			});
		},
        //编辑
        edit(id,type) {
            this.$router.replace({
                path: `/system/serviceTemplate/edit/${id}/${type}`,
                query: {
                    v: this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //删除事件
        del(id) {
            this.$confirm('确定要删除吗?', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/service/template/delete',
                    method: 'POST',
                    params: { id: id }
                }).then(res => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.getDataList();
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            })
        }
    },
};
</script>
